import styled, { css } from 'styled-components';
import {
  Dropdown as SemanticDropdown,
  Table as SemanticTable,
  Modal as SemanticModal,
  Tab,
} from 'semantic-ui-react';

import { Text } from '@playbookux/playbook-web-core';

export const TabMenu = styled(Tab)`
  width: 100%;
  .ui.secondary.menu .active.item {
    background: ${(props) => props.theme.color.highlight};
  }
`;

const Modal = styled(SemanticModal)``;

const Table = styled(SemanticTable)`
  &&& {
    margin: 0px;
    padding: 0px;
    width: 100%;
    color: inherit;
  }
`;

const Row = styled(SemanticTable.Row)``;

const Column = styled(SemanticTable.Cell)`
  word-break: break-all;

  &&& {
    padding-top: 11px;
  }
`;

const Header = styled(SemanticTable.Header)``;

const HeaderCell = styled(SemanticTable.HeaderCell)`
  &&& {
    border-bottom: 0px;
    padding-bottom: 13px;
  }
`;

const HeaderLabel = styled(Text.Secondary)`
  font-weight: 500;
`;

const Body = styled(SemanticTable.Body)``;

const Link = styled.a`
  ${(props) => props.bold && css`
    font-weight: bold;
  `}
`;

const Dropdown = styled(SemanticDropdown)`
  &&& {

    &&:hover {
      background: ${({ theme }) => theme.color.white};

    }
    &.active {
      background: ${({ theme }) => theme.color.white};
    }
    &.ui.dropdown>.dropdown.icon{
      display: none;
    }
  }
`;

const ContainerCenter = styled.div`
  display: flex;
  justify-content: center;
`;

const ContainerContent = styled.div`
  padding: 50px 25px;
`;

export const ModalLoaderContainer = styled.div`
  padding: 50px 25px;
  display: flex;
  justify-content: center;
`;

export const ScreenerContainer = styled.div`
  padding: 0px 34px;
`;

export const ProfileWrapper = styled.div`
    div div div div.column {
    padding-left: 0px !important;
    margin-left: 5px !important;
  }
`;

const ErrorText = styled(Text.Error)``;

export const Container = styled.div`
  display: flex;
  padding: 0px 34px;
  width: 100%;
`;

export {
  Column,
  Table,
  Body,
  Link,
  Row,
  Dropdown,
  ContainerCenter,
  Header,
  HeaderCell,
  HeaderLabel,
  Modal,
  ContainerContent,
  ErrorText,
};
